import { getAuthAxiosBackend } from "../helpers/axios"

class PolicieServices{

    getByTableName(tbName){
        return getAuthAxiosBackend().get('PoliceFields/getByTableName/' + tbName)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('PoliceFields/all', {params: data})
    }

    edit(tbName, data){
        return getAuthAxiosBackend().put('PoliceFields/updateByTableName/' + tbName, data)
    }
}

export default new PolicieServices()